module.exports = __webpack_public_path__ + "static/img/bonus_6.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_6.png
// module id = 7i6I
// module chunks = 0